import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './comp/home/home.component';
import { CourtierComponent } from './comp/courtier/courtier.component';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'courtier-assurance', component: CourtierComponent},
 {
    path: 'contact',
    loadChildren: () =>
      import('./comp/contact/contact.routes').then(m => m.CONTACT_ROUTES),
  },
  {path: 'actualites',  loadComponent: () => import('./comp/actualites/actualites.component').then(m => m.ActualitesComponent) },
  {path: 'articles/1', loadComponent: () => import('./comp/article/article.component').then(m => m.ArticleComponent) },
  {path: 'articles/2', loadComponent: () => import('./comp/article2/article2.component').then(m => m.Article2Component) },
  {path: 'articles/3', loadComponent: () => import('./comp/article3/article3.component').then(m => m.Article3Component) },
  {path: 'articles/4', loadComponent: () => import('./comp/article4/article4.component').then(m => m.Article4Component) },
  {path: 'articles/5', loadComponent: () => import('./comp/article5/article5.component').then(m => m.Article5Component) },
  {path: 'articles/6', loadComponent: () => import('./comp/article6/article6.component').then(m => m.Article6Component) },
  {path: 'articles/7', loadComponent: () => import('./comp/article7/article7.component').then(m => m.Article7Component) },
  {path: 'articles/8', loadComponent: () => import('./comp/article8/article8.component').then(m => m.Article8Component) },
  {path: 'assurance-auto', loadComponent: () => import('./comp/ass-auto/ass-auto.component').then(m => m.AssAutoComponent) },
  {path: 'assurance-habitation',loadComponent: () => import('./comp/ass-habit/ass-habit.component').then(m => m.AssHabitComponent) },
  {path: 'assurance-accidents', loadComponent: () => import('./comp/ass-acc/ass-acc.component').then(m => m.AssAccComponent) },
  {path: 'assurance-professionnelle', loadComponent: () => import('./comp/ass-pro/ass-pro.component').then(m => m.AssProComponent) },
  {path: 'assurance-sante', loadComponent: () => import('./comp/ass-sante/ass-sante.component').then(m => m.AssSanteComponent) },
  {path: 'assurance-pret', loadComponent: () => import('./comp/ass-pret/ass-pret.component').then(m => m.AssPretComponent) },
  {path: 'cryptomonnaies', loadComponent: () => import('./comp/crypto/crypto.component').then(m => m.CryptoComponent) },
  {path: 'mentions-legales', loadComponent: () => import('./comp/mentions-legales/mentions-legales.component').then(m => m.MentionsLegalesComponent) },
  {path: 'vie-privee', loadComponent: () => import('./comp/vie-privee/vie-privee.component').then(m => m.ViePriveeComponent) },
  {path: 'privacy', loadComponent: () => import('./comp/privacy/privacy.component').then(m => m.PrivacyComponent) },
  {path: '404', loadComponent: () => import('./comp/not-found/not-found.component').then(m => m.NotFoundComponent) },
  {path: '**', redirectTo: '404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
